var map = {
	"./arnolfini-portrait/hero-small.jpg": 9649,
	"./girl-with-a-pearl-earring/hero-small.jpg": 6981,
	"./guernica/hero-small.jpg": 6395,
	"./lady-with-an-ermine/hero-small.jpg": 5747,
	"./mona-lisa/hero-small.jpg": 263,
	"./penitent-magdalene/hero-small.jpg": 5809,
	"./starry-night/hero-small.jpg": 3619,
	"./the-basket-of-apples/hero-small.jpg": 2905,
	"./the-boy-in-the-red-vest/hero-small.jpg": 7422,
	"./the-great-wave-off-kanagawa/hero-small.jpg": 528,
	"./the-night-cafe/hero-small.jpg": 505,
	"./the-sleeping-gypsy/hero-small.jpg": 8630,
	"./the-storm-on-the-sea-of-galilee/hero-small.jpg": 3621,
	"./the-swing/hero-small.jpg": 682,
	"./van-gogh-self-portrait/hero-small.jpg": 2820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3542;